<template>
  <div>
      <textarea  :class="{'ust-textstyle': isUSTWall || isSimple, 'textstyle' : !isTextareaHalf, 'textstyle-half' : isTextareaHalf}" v-show="showInputFlag" v-model="textData" ref="textData" @keyup="textDataKeyUp"></textarea>
      <pre class="textstyle-half" :class="{'ust-textstyle': isUSTWall || isSimple}" v-show="!showInputFlag">{{ textData }}</pre>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'commentArea',
  props: {
    isUSTWall: {
      type: Boolean,
      default: false
    },
    isSimple: {
      type: Boolean,
      default: false
    },
    isTextareaHalf: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapState([
      'showInputFlag', 'textDataView'
    ]),
    textData: {
      get () {
        return this.textDataView
      },
      set (val) {
        return this.SET_TEXTDATA(val)
      }
    }
  },
  watch: {
    textData () {
      if (this.isUSTWall) {
        let textdata = this.$refs.textData
        textdata.setAttribute('maxlength', 260)
      }
    }
  },
  methods: {
    ...mapMutations(['SET_TEXTDATA']),
    textDataKeyUp () {
      if (this.isUSTWall) {
        let obj = this.textData.split(/\n/g)
        if (obj.length - 1 > 3) {
          this.textData = this.textData.slice(0, this.textData.length - 1)
        }
      }
    }
  }
}
</script>
<style scoped>
.textstyle {
  width: 500px;
  height: 335px;
  font-size: 16px;
  color: #000000;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background-color: #f3f3f2;
  padding: 20px;
  margin-top: 30px;
  resize: none;
  outline: none;
  text-align: left;
  overflow: auto;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
}
.textstyle-half{
  width: 500px;
  height: 100px;
  font-size: 16px;
  color: #000000;
  border: 1px solid #c1c1c1;
  border-radius: 5px;
  background-color: #f3f3f2;
  padding: 20px;
  margin-top: 30px;
  resize: none;
  outline: none;
  text-align: left;
  overflow: auto;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
}
.ust-textstyle{
  width: 1070px;
  height: 85px;
  margin-top: 5px;
  padding: 10px;
  line-height: 15px;
  overflow: hidden;
  font-family: "Helvetica Neue", Helvetica, Arial, 'Avenir', sans-serif;
  -webkit-font-smoothing: antialiased;
}
pre {
white-space: pre-wrap;       /* css-3 */
white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
white-space: -pre-wrap;      /* Opera 4-6 */
white-space: -o-pre-wrap;    /* Opera 7 */
word-wrap: break-word;       /* Internet Explorer 5.5+ */
word-break:break-all;
overflow:hidden;
}
</style>



// WEBPACK FOOTER //
// src/view/result/commentArea.vue